export default __webpack_public_path__ + "static/media/searchspring.90ca3518.svg";